let env = {};

env.baseURL = 'https://api.admin-survey.it4d.com.br/api/v1/';
env.normalURL = 'https://api.admin-survey.it4d.com.br/';
env.mode = 'homolog';
env.wsHost = 'localhost';
//env.mode = 'contingencia';
//env.mode = 'production';
//env.mode = 'development';

export default env
